import ConnectDomainModal from "./ConnectDomainModal"

export default ConnectDomainModal
